import { getFieldFromUa } from '../../bom/ua/getFieldFromUa';

/**
 * 获取内部版本号
 * 
 * 从 UserAgent 中提取 innerversion 字段的值，通常用于获取应用的内部版本号。
 * 
 * @returns 内部版本号字符串，如果未找到则返回 false
 * 
 * @example
 * ```ts
 * import { getInnerVersion } from '@fu/matrix';
 * 
 * // UserAgent: "iHexin/10.80.60 (iPhone; innerversion/iosv1.2.3) WebKit/537.36"
 * getInnerVersion(); // => "iosv1.2.3"
 * 
 * // UserAgent: "IHexin_Futures/8.90.50 (Android; innerversion/andv2.1.0) WebKit/537.36"
 * getInnerVersion(); // => "andv2.1.0"
 * 
 * // 没有内部版本号时
 * getInnerVersion(); // => false
 * ```
 * 
 * @since 1.3.0
 */
export function getInnerVersion(): string | false {
  return getFieldFromUa('innerversion');
} 